import Footer from "../../components/footer";
import React, { useState } from "react";
import "./email.css";
import { useNavigate } from "react-router-dom";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import InputField from "../../components/input/inputField";

const Email = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/grow/password", { state: { email: email } });
    // TODO: Implement your sign-in logic here
    console.log("Email submitted:", email);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SignupToolbar />
      <div className="email-container">
        <div className="email-form-wrapper">
          <h2 className="email-heading">To log in, enter your email address</h2>
          <InputField
            name="email"
            title="Email"
            placeholder="Enter email address"
            isRequired={true}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" onClick={handleSubmit} className="email-button">
            Continue
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Email;
